// extracted by mini-css-extract-plugin
module.exports =  {"tc-resource-picker-name-filter":"NameFilter-module__tc-resource-picker-name-filter___D9w1z","remove":"NameFilter-module__remove___qJyR9"};